import type { ReactNode } from "react";
import { AnimatedNumber } from "./AnimatedNumber";

type Metric = {
  key: "findings" | "hypoteses" | "endpoints";
  label: string;
  sub: ReactNode;
  value: string;
  valueCjk?: boolean;
  icon: ReactNode;
};

export function MetricCards({ metrics }: { metrics: Metric[] }) {
  return (
    <div className="metrics" data-tour="metrics">
      {metrics.map((m) => (
        <div className="metric" key={m.key}>
          <div className="metric__head">
            <div>
              <p className="metric__label">{m.label}</p>
              <p className={`metric__sub${typeof m.sub === "string" && m.sub.match(/[一-鿿]/) ? " metric__sub--cjk" : ""}`}>{m.sub}</p>
            </div>
            <span className="metric__icon">{m.icon}</span>
          </div>
          <p
            // Remount when the card switches from its placeholder to a real
            // number, so the value pops in as the threats are discovered.
            key={m.valueCjk ? "cjk" : "num"}
            className={`metric__value${m.valueCjk ? " metric__value--cjk" : " metric__value--reveal"}`}
          >
            {m.valueCjk ? m.value : <AnimatedNumber value={m.value} durationMs={1600} />}
          </p>
        </div>
      ))}
    </div>
  );
}
